'use client';

import styles from './styles.module.css';

import { CampaignBanner } from '@/components/CampaignBanner';

export function TopSellerBanner() {
  return (
    <CampaignBanner alwaysVisible className={styles.banner}>
      <span className={styles.bannerItem}>
        <img
          className={styles.stampImage}
          src={`${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/topSellerProgram/depop-top-seller-stamp.svg`}
          alt=""
          aria-hidden="true"
        />
        <span className={styles.divider} />
      </span>
    </CampaignBanner>
  );
}
